import React, { useContext, useState, useEffect } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { media } from '../../utils/media';
import { COLOR_MAPPING_INFOGRAPHIC } from '../../constants';
const DonutContainer = styled.div `
  width: 90%;
  margin: 0px auto;
  .recharts-wrapper {
    display: flex;
    justify-content: center;
  }

  .recharts-surface {
    overflow: inherit;
  }

  .recharts-responsive-container {
    height: 295px;

    .recharts-curve.recharts-pie-label-line {
      stroke: ${({ theme }) => theme.primaryBlack};
    }

    ${media.mobile} {
      max-height: 140px;
    }
    .recharts-wrapper {
      max-height: 285px;
      display: flex;
      align-items: center;

      ${media.mobile} {
        max-height: 130px;
      }
    }
  }

  text {
    font-size: 16px;
    line-height: 18px;
    font-family: ${({ theme }) => theme.fontFamilyBase};

    ${media.mobile} {
      font-size: 14px;
      line-height: 16px;
    }
  }

  .value {
    font-family: ${({ theme }) => theme.fontFamilyBold};
  }

  @media (max-width: 767px) {
    padding: 0px;
    margin: 0 auto;
    width: 75%;
  }
`;
export const DonutChart = ({ data, initiateAnimate }) => {
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const themeContext = useContext(ThemeContext);
    useEffect(() => {
        if (initiateAnimate) {
            setShouldAnimate(true);
        }
    }, [initiateAnimate]);
    const { isWindowMobile, primaryBlack } = themeContext;
    const height = isWindowMobile ? 140 : 380;
    return (React.createElement(DonutContainer, null,
        React.createElement(ResponsiveContainer, { width: "100%", height: height },
            React.createElement(PieChart, null,
                React.createElement(Pie, { data: data, cx: "50%", cy: "50%", innerRadius: isWindowMobile ? '70%' : '50%', outerRadius: isWindowMobile ? '100%' : '75%', fill: "#8884d8", dataKey: "value", startAngle: 90, endAngle: shouldAnimate ? -270 : 90, label: ({ cx, cy, midAngle, outerRadius, innerRadius, value, name }) => {
                        const parsedCx = parseFloat(cx);
                        const parsedCy = parseFloat(cy);
                        const parsedOuterRadius = parseFloat(outerRadius);
                        const parsedInnerRadius = parseFloat(innerRadius);
                        const RADIAN = Math.PI / 180;
                        // for mobile
                        const radius = 25 + parsedInnerRadius + (parsedOuterRadius - parsedInnerRadius);
                        const x = parsedCx + radius * Math.cos(-midAngle * RADIAN);
                        const y = parsedCy + radius * Math.sin(-midAngle * RADIAN);
                        // for web
                        const sin = Math.sin(-RADIAN * midAngle);
                        const cos = Math.cos(-RADIAN * midAngle);
                        const sx = parsedCx + parsedOuterRadius * cos;
                        const sy = parsedCy + parsedOuterRadius * sin;
                        const mx = parsedCx + (parsedOuterRadius + 20) * cos;
                        const my = parsedCy + (parsedOuterRadius + 20) * sin;
                        const ex = mx + (cos >= 0 ? 1 : -1) * 22;
                        const ey = my;
                        const textAnchor = cos >= 0 ? 'start' : 'end';
                        if (isWindowMobile) {
                            return (React.createElement("g", null,
                                React.createElement("text", { x: x, y: y, className: "value", fill: primaryBlack, textAnchor: x > parsedCx ? 'start' : 'end', dominantBaseline: "central" },
                                    value,
                                    "%"),
                                React.createElement("text", { x: x, y: y + 15, fill: primaryBlack, textAnchor: x > parsedCx ? 'start' : 'end', dominantBaseline: "central" }, name)));
                        }
                        else {
                            return name.length > 20 ? (
                            /* Special case for long names. SVG does not support text wrapping, so we inject an HTML object to enable auto-wrap */
                            React.createElement("g", null,
                                React.createElement("path", { d: `M${sx},${sy}L${mx},${my}L${ex},${ey}`, stroke: primaryBlack, fill: 'none' }),
                                React.createElement("text", { className: "value", x: ex + (cos >= 0 ? 1 : -1) * 12, y: ey, textAnchor: textAnchor, fill: "#333" }, `${value}%`),
                                React.createElement("foreignObject", { x: ex + (cos >= 0 ? 1 : -1) * 12, y: ey + 15, width: "150px", height: height },
                                    React.createElement("span", null, name)))) : (React.createElement("g", null,
                                React.createElement("path", { d: `M${sx},${sy}L${mx},${my}L${ex},${ey}`, stroke: primaryBlack, fill: 'none' }),
                                React.createElement("text", { className: "value", x: ex + (cos >= 0 ? 1 : -1) * 12, y: ey, textAnchor: textAnchor, fill: "#333" }, `${value}%`),
                                React.createElement("text", { x: ex + (cos >= 0 ? 1 : -1) * 12, y: ey + 15, textAnchor: textAnchor, fill: "#333" }, name)));
                        }
                    } }, data.map((_, index) => (React.createElement(Cell, { key: `cell-${index}`, fill: COLOR_MAPPING_INFOGRAPHIC[index], stroke: COLOR_MAPPING_INFOGRAPHIC[index] }))))))));
};
